/* eslint-disable consistent-return */
import { useState, useEffect } from 'react';

export const getStorageValue = (key: string, defaultValue: any) => {
	if (typeof window !== 'undefined') {
		const saved = localStorage.getItem(key);
		const initial = saved !== null ? JSON.parse(saved) : defaultValue;
		return initial;
	}
};

export const useLocalStorage = (key: string, defaultValue: any) => {
	const [value, setValue] = useState(() => getStorageValue(key, defaultValue));

	useEffect(() => {
		localStorage.setItem(key, JSON.stringify(value));
	}, [key, value]);

	return [value, setValue];
};